import classnames from 'classnames';
import compose from 'lodash/fp/compose';
import { bool, func, number, object, shape } from 'prop-types';
import React, { Component } from 'react';
import { GoBell } from 'react-icons/go';
import { Button } from 'reactstrap';

import { sessionShape } from '../../prop-types';
import api from '../../REST/api';
import withApiRequest from '../../REST/with-api-request';
import withSessionInfo from '../../signin/with-session-info';
import { POLLING_INTERVAL } from '../CommentsState';

class NotificationsBell extends Component {
  componentDidMount() {
    this.intervalId = setInterval(
      this.updateUnreadNotificationsCount.bind(this),
      POLLING_INTERVAL * 1000,
    );
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  updateUnreadNotificationsCount() {
    const { isDrawerOpen, loading, onRequest, session } = this.props;

    if (isDrawerOpen || loading || !session) {
      return;
    }

    onRequest().catch(console.error); // eslint-disable-line no-console
  }

  render() {
    const { onClick, response, error } = this.props;
    const unreadCount = response ? response.unread_count : 0;

    return (
      <Button
        color="link"
        className={classnames('btn nav-link c-notifications-btn', {
          'text-primary': unreadCount,
          'text-danger': !!error,
        })}
        id="notifications-comments-button"
        onClick={onClick}
      >
        <GoBell />
        <span className="c-notifications-btn__count">
          {unreadCount > 0 ? unreadCount : ''}
        </span>
      </Button>
    );
  }
}

NotificationsBell.propTypes = {
  session: sessionShape,

  onRequest: func.isRequired,
  error: object, // eslint-disable-line react/forbid-prop-types
  loading: bool.isRequired,
  response: shape({ unread_count: number.isRequired }),

  onClick: func.isRequired,
  isDrawerOpen: bool.isRequired,
};

NotificationsBell.defaultProps = {
  session: null,
  error: undefined,
  response: null,
};

export default compose([
  withApiRequest({
    query: api.getUnreadNotificationsCount,
    error: 'ignore',
  }),
  withSessionInfo,
])(NotificationsBell);
